
import React, { useMemo, useEffect } from 'react';
import moment from 'moment';
import { SalesOrderInfo, selectServicesTranslations, fetchServicesTranslations } from '../../../store/slices/salesOrders';
import styles from './AppointmentDetails.module.scss';
import { useConsultationContext } from '../../../context/ConsultationContext';
import { useTranslation } from '../../../hooks/useTranslations';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { buildTranslatedServicesMap, getTranslatedServicesName } from '../../../utils/miscUtils';

type Props = {
  selectedListOrder: SalesOrderInfo;
  setAssignDoctor: (value: boolean) => void;
};

const AppointmentDetails: React.FC<Props> = ({ selectedListOrder, setAssignDoctor }) => {
  const { translations } = useTranslation();
  const { selectedDoctor } = useConsultationContext();
  const dispatch = useAppDispatch();

  const servicesTranslations = useAppSelector(selectServicesTranslations);
  const lang = (localStorage.getItem('lang') || 'en').toLowerCase().trim();

  useEffect(() => {
    dispatch(fetchServicesTranslations());
  }, [dispatch]);


  const translatedServicesMap = useMemo(
  () => buildTranslatedServicesMap(servicesTranslations, lang),
  [servicesTranslations, lang]
);
  if (!selectedListOrder) return <div></div>;

  const lessThanOneHour =
    selectedListOrder.sales_order_appointment.start
      ? new Date(selectedListOrder.sales_order_appointment.start).getTime() > new Date().getTime() &&
        new Date(selectedListOrder.sales_order_appointment.start).getTime() - new Date().getTime() < 3600000
      : false;

  const handleAssignDoctor = () => setAssignDoctor(true);

  return (
    <div style={{ padding: '0px 20px' }}>
      <div className={styles.container}>
        <div>
          <p>{translations('appointment.id')}</p>
          <div>{selectedListOrder.sales_order.sales_order_id}</div>
        </div>
        <div>
          <p>{translations('patient')}</p>
          <div>
            {selectedListOrder.customer_person.person_firstname}{' '}
            {selectedListOrder.customer_person.person_lastname}
          </div>
        </div>
        <div>
          <p>{translations('start')}</p>
          <div className={styles.timeLeft} style={lessThanOneHour ? { color: '#FC5E4D' } : {}}>
            {selectedListOrder.sales_order_appointment.start
              ? moment(selectedListOrder.sales_order_appointment.start).fromNow()
              : translations('walkin_appointment')}
          </div>
        </div>
      </div>

      <div className={styles.container}>
        <div>
          <p>{translations('date_and_time')}</p>
          <div>
            {selectedListOrder.sales_order_appointment.start
              ? moment(selectedListOrder.sales_order_appointment.start).format('DD.MM.YYYY  |  HH:mm -')
              : translations('walkin_appointment')}
            {selectedListOrder.sales_order_appointment.start
              ? moment(selectedListOrder.sales_order_appointment.end_time).format(' HH:mm')
              : ''}
          </div>
        </div>

        <div>
          <p>{translations('service')}</p>
          <div>
            {getTranslatedServicesName(
              selectedListOrder.service.service_id,
            translatedServicesMap 
            )}
          </div>
        </div>

        <div>
          <p>{translations('appointment.doctor')}</p>
          <a onClick={handleAssignDoctor}>
            {selectedDoctor
              ? `${translations('label.assigned')} ${selectedDoctor.person_firstname} ${selectedDoctor.person_lastname}`
              : translations('doctor.assign')}
          </a>
        </div>
      </div>
    </div>
  );
};

export { AppointmentDetails };

